<script>
    import { t } from '../core/i18n/language-store';
    import WidgetYandexBusiness from './WidgetYandexBusiness.svelte';
    import {mediaUrlStore} from "../core/app-store.js";
    export let publishConfig;
    export let tenantKey;
</script>
<style>
    .footer-container {
        padding: 1.5rem 1.5rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
    .footer-restaurant-name {
        font-family: Roboto Condensed, sans-serif;
        font-size: 56px;
        font-weight: 900;
        line-height: 80%;
        color: var(--accent-color);
        overflow-wrap: break-word;
    }
    .info-label {
        font-family: PT Mono, sans-serif;
        font-size: 16px;
        color: var(--secondary-font-color);
        font-weight: 100;
        margin-bottom: .25em;
    }
    .phone,
    .address {
        font-family: PT Mono, sans-serif;
        text-transform: uppercase;
        color: var(--main-font-color);
        line-height: 100%;
        font-size: 16px;
    }
    .address a {
        font-size: .8em;
        color: var(--accent-color);
    }
    .doc-link {
        font-family: PT Mono, sans-serif;
        color: var(--main-font-color);
        line-height: 100%;
        font-size: 16px;
        opacity: .8;
    }

    .row {
        display: flex;
        flex-direction: column;
    }
    .row--title {
        gap: 1rem;
    }
    .row--info {
        gap: 1.5rem;
    }

    .logo {
        width: 96px;
    }

    @media (min-width: 768px) {
        .footer-container {
            padding-left: 0;
            padding-right: 0;
        }
        .row {
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-end;
        }
        .row--title {
            flex-direction: row-reverse;
            align-items: flex-start;
        }
    }
</style>

<div class="footer-container layer-sections">

    <div class="row row--title">

        <img class="logo" src="{$mediaUrlStore}{tenantKey}{publishConfig.logoUrl}" alt="">

        <div class="flex-column gap-05">
            <h2 class="footer-restaurant-name">
                {publishConfig.restaurantName}
            </h2>

            {#if publishConfig.ybId}
                <WidgetYandexBusiness
                    ybId={publishConfig.ybId}
                    ybWidgetTheme={publishConfig.ybWidgetTheme}
                />
            {/if}
        </div>

    </div>

    <div class="row row--info">
        <div class="flex-column gap-1">
            {#if publishConfig.restaurantAddress}

                <div>
                    <div class="info-label hide-on-mobile">
                        {$t('footer.address')}
                    </div>
                    <div class="address">

                <span>
                    {publishConfig.restaurantAddress}
                </span>

                        {#if (publishConfig.restaurantAddressLinkAction === 'yandex-maps' && publishConfig.restaurantAddressLink)}
                            <a href="{publishConfig.restaurantAddressLink}" target="_blank" rel="nofollow noopener">
                                <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.47133 8.47134L9.66667 3.27601L10.862 4.47134C10.9552 4.56454 11.074 4.62802 11.2033 4.65373C11.3326 4.67944 11.4666 4.66624 11.5884 4.61579C11.7102 4.56534 11.8143 4.47992 11.8876 4.37031C11.9609 4.2607 12 4.13184 12 4.00001V0.666672L11.9993 0.634672C11.9918 0.463355 11.9182 0.301612 11.7941 0.18331C11.6699 0.0650077 11.5048 -0.000678585 11.3333 5.28681e-06H8C7.86817 3.34364e-05 7.7393 0.039148 7.62969 0.112404C7.52009 0.18566 7.43466 0.289769 7.38421 0.411569C7.33377 0.533369 7.32057 0.667391 7.34628 0.796693C7.37199 0.925995 7.43546 1.04477 7.52867 1.13801L8.724 2.33334L3.52867 7.52867C3.46499 7.59017 3.4142 7.66373 3.37927 7.74507C3.34433 7.8264 3.32594 7.91388 3.32517 8.0024C3.3244 8.09092 3.34127 8.17871 3.37479 8.26064C3.40831 8.34257 3.45781 8.41701 3.5204 8.4796C3.583 8.5422 3.65743 8.5917 3.73936 8.62522C3.82129 8.65874 3.90908 8.67561 3.9976 8.67484C4.08612 8.67407 4.1736 8.65568 4.25494 8.62074C4.33627 8.5858 4.40984 8.53501 4.47133 8.47134ZM0.666667 5.28681e-06C0.489856 5.28681e-06 0.320286 0.0702431 0.195262 0.195267C0.0702379 0.320292 0 0.489861 0 0.666672V10C0 10.5304 0.210714 11.0391 0.585787 11.4142C0.960859 11.7893 1.46957 12 2 12H10C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10V6.66667C12 6.48986 11.9298 6.32029 11.8047 6.19527C11.6797 6.07024 11.5101 6 11.3333 6C11.1565 6 10.987 6.07024 10.8619 6.19527C10.7369 6.32029 10.6667 6.48986 10.6667 6.66667V10C10.6667 10.1768 10.5964 10.3464 10.4714 10.4714C10.3464 10.5964 10.1768 10.6667 10 10.6667H2C1.82319 10.6667 1.65362 10.5964 1.5286 10.4714C1.40357 10.3464 1.33333 10.1768 1.33333 10V1.33334H5.33333C5.51014 1.33334 5.67971 1.2631 5.80474 1.13808C5.92976 1.01305 6 0.843483 6 0.666672C6 0.489861 5.92976 0.320292 5.80474 0.195267C5.67971 0.0702431 5.51014 5.28681e-06 5.33333 5.28681e-06H0.666667Z" fill="currentColor"/>
                                </svg>
                            </a>
                        {:else if (publishConfig.restaurantAddressLinkAction === 'geo' && publishConfig.restaurantAddressGeo)}
                    <span class="hide-on-desktop">
                        <a href="geo:{publishConfig.restaurantAddressGeo}" target="_blank" rel="nofollow noopener">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.47133 8.47134L9.66667 3.27601L10.862 4.47134C10.9552 4.56454 11.074 4.62802 11.2033 4.65373C11.3326 4.67944 11.4666 4.66624 11.5884 4.61579C11.7102 4.56534 11.8143 4.47992 11.8876 4.37031C11.9609 4.2607 12 4.13184 12 4.00001V0.666672L11.9993 0.634672C11.9918 0.463355 11.9182 0.301612 11.7941 0.18331C11.6699 0.0650077 11.5048 -0.000678585 11.3333 5.28681e-06H8C7.86817 3.34364e-05 7.7393 0.039148 7.62969 0.112404C7.52009 0.18566 7.43466 0.289769 7.38421 0.411569C7.33377 0.533369 7.32057 0.667391 7.34628 0.796693C7.37199 0.925995 7.43546 1.04477 7.52867 1.13801L8.724 2.33334L3.52867 7.52867C3.46499 7.59017 3.4142 7.66373 3.37927 7.74507C3.34433 7.8264 3.32594 7.91388 3.32517 8.0024C3.3244 8.09092 3.34127 8.17871 3.37479 8.26064C3.40831 8.34257 3.45781 8.41701 3.5204 8.4796C3.583 8.5422 3.65743 8.5917 3.73936 8.62522C3.82129 8.65874 3.90908 8.67561 3.9976 8.67484C4.08612 8.67407 4.1736 8.65568 4.25494 8.62074C4.33627 8.5858 4.40984 8.53501 4.47133 8.47134ZM0.666667 5.28681e-06C0.489856 5.28681e-06 0.320286 0.0702431 0.195262 0.195267C0.0702379 0.320292 0 0.489861 0 0.666672V10C0 10.5304 0.210714 11.0391 0.585787 11.4142C0.960859 11.7893 1.46957 12 2 12H10C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10V6.66667C12 6.48986 11.9298 6.32029 11.8047 6.19527C11.6797 6.07024 11.5101 6 11.3333 6C11.1565 6 10.987 6.07024 10.8619 6.19527C10.7369 6.32029 10.6667 6.48986 10.6667 6.66667V10C10.6667 10.1768 10.5964 10.3464 10.4714 10.4714C10.3464 10.5964 10.1768 10.6667 10 10.6667H2C1.82319 10.6667 1.65362 10.5964 1.5286 10.4714C1.40357 10.3464 1.33333 10.1768 1.33333 10V1.33334H5.33333C5.51014 1.33334 5.67971 1.2631 5.80474 1.13808C5.92976 1.01305 6 0.843483 6 0.666672C6 0.489861 5.92976 0.320292 5.80474 0.195267C5.67971 0.0702431 5.51014 5.28681e-06 5.33333 5.28681e-06H0.666667Z" fill="currentColor"/>
                            </svg>
                        </a>
                    </span>
                        {:else if (publishConfig.restaurantAddressLinkAction !== 'none')}
                            <a href="https://maps.google.com/?q={publishConfig.restaurantAddress}" target="_blank" rel="nofollow noopener">
                                <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.47133 8.47134L9.66667 3.27601L10.862 4.47134C10.9552 4.56454 11.074 4.62802 11.2033 4.65373C11.3326 4.67944 11.4666 4.66624 11.5884 4.61579C11.7102 4.56534 11.8143 4.47992 11.8876 4.37031C11.9609 4.2607 12 4.13184 12 4.00001V0.666672L11.9993 0.634672C11.9918 0.463355 11.9182 0.301612 11.7941 0.18331C11.6699 0.0650077 11.5048 -0.000678585 11.3333 5.28681e-06H8C7.86817 3.34364e-05 7.7393 0.039148 7.62969 0.112404C7.52009 0.18566 7.43466 0.289769 7.38421 0.411569C7.33377 0.533369 7.32057 0.667391 7.34628 0.796693C7.37199 0.925995 7.43546 1.04477 7.52867 1.13801L8.724 2.33334L3.52867 7.52867C3.46499 7.59017 3.4142 7.66373 3.37927 7.74507C3.34433 7.8264 3.32594 7.91388 3.32517 8.0024C3.3244 8.09092 3.34127 8.17871 3.37479 8.26064C3.40831 8.34257 3.45781 8.41701 3.5204 8.4796C3.583 8.5422 3.65743 8.5917 3.73936 8.62522C3.82129 8.65874 3.90908 8.67561 3.9976 8.67484C4.08612 8.67407 4.1736 8.65568 4.25494 8.62074C4.33627 8.5858 4.40984 8.53501 4.47133 8.47134ZM0.666667 5.28681e-06C0.489856 5.28681e-06 0.320286 0.0702431 0.195262 0.195267C0.0702379 0.320292 0 0.489861 0 0.666672V10C0 10.5304 0.210714 11.0391 0.585787 11.4142C0.960859 11.7893 1.46957 12 2 12H10C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10V6.66667C12 6.48986 11.9298 6.32029 11.8047 6.19527C11.6797 6.07024 11.5101 6 11.3333 6C11.1565 6 10.987 6.07024 10.8619 6.19527C10.7369 6.32029 10.6667 6.48986 10.6667 6.66667V10C10.6667 10.1768 10.5964 10.3464 10.4714 10.4714C10.3464 10.5964 10.1768 10.6667 10 10.6667H2C1.82319 10.6667 1.65362 10.5964 1.5286 10.4714C1.40357 10.3464 1.33333 10.1768 1.33333 10V1.33334H5.33333C5.51014 1.33334 5.67971 1.2631 5.80474 1.13808C5.92976 1.01305 6 0.843483 6 0.666672C6 0.489861 5.92976 0.320292 5.80474 0.195267C5.67971 0.0702431 5.51014 5.28681e-06 5.33333 5.28681e-06H0.666667Z" fill="currentColor"/>
                                </svg>
                            </a>
                        {/if}

                    </div>
                </div>
            {/if}

            {#if publishConfig.restaurantPhone}
                <div>
                    <div class="info-label hide-on-mobile">
                        {$t('footer.contacts')}
                    </div>
                    <div class="phone">
                        { publishConfig.restaurantPhone }
                    </div>
                </div>
            {/if}
        </div>
        <div class="flex-column">
            {#if (publishConfig.docs)   }
                <a class="doc-link" href="./privacy-policy.html">{$t('footer.privacyPolicy')}</a>
                <a class="doc-link" href="./user-agreement.html">{$t('footer.termsOfUse')}</a>
            {/if}
        </div>
    </div>

</div>
